/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Page_DescriptionInputs */

const vi_media_page_description = /** @type {(inputs: Media_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ảnh và video dùng cho website và Zalo Mini App. Kéo thả file vào đây hoặc bấm Tải lên; bấm một file để sửa mô tả, xem nơi đang dùng hoặc xoá.`)
};

/**

* @param {Media_Page_DescriptionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_page_description = /** @type {((inputs?: Media_Page_DescriptionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Page_DescriptionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_page_description(inputs)
});